import { inject } from '@angular/core';
import { NavigationError, RedirectCommand, Router } from '@angular/router';
import { AppUpdateService } from '../services/app-update.service';
import { SessionService } from '../services/session.service';

export function handleNavigationError(error: NavigationError): RedirectCommand | void {
  // After authentication is cleared, recover failed navigation with the eager login route.
  const signedOut = !inject(SessionService).sessionSnapshot;
  const login = inject(Router).parseUrl('/login');
  if (signedOut && error.url.split(/[;?#]/, 1)[0] !== '/login') return new RedirectCommand(login, { replaceUrl: true });
  // A deploy may have removed this route's lazy bundle; the page reloads once that is
  // confirmed. Other errors stay with Angular's handler.
  inject(AppUpdateService).recoverFromLoadFailure(error);
}
